
import { defineComponent, PropType } from 'vue'
import DataPreparationSplitDescriptor from '@/modules/workspace/dataPreparation/DataPreparationCustom/DataPreparationSplitDescriptor.json'
import { ISplitTransformationParameter } from '@/modules/workspace/dataPreparation/DataPreparation'
import { IDataPreparationColumn } from '@/modules/workspace/dataPreparation/DataPreparation'
import Dropdown from 'primevue/dropdown'
import Fieldset from 'primevue/fieldset'

export default defineComponent({
    name: 'data-preparation-split-transformation',

    props: { columns: { type: Array as PropType<Array<IDataPreparationColumn>> }, col: String, readOnly: Boolean, transformation: {} as any },

    components: { Dropdown, Fieldset },
    emits: ['update:transformation'],
    data() {
        return {
            availableConditions: DataPreparationSplitDescriptor.condition.availableOptions as Array<any>,
            availableOutputTypes: DataPreparationSplitDescriptor.availableOutputTypes as Array<any>,
            descriptor: DataPreparationSplitDescriptor as any,
            localTransformation: {} as ISplitTransformationParameter
        }
    },
    mounted() {
        this.localTransformation = {} as ISplitTransformationParameter
        if (this.readOnly && this.transformation && this.transformation.parameters) {
            for (let i = 0; i < this.transformation.parameters.length; i++) {
                if (this.transformation.parameters[i]['name'] == 'condition') this.localTransformation.condition = this.transformation.parameters[i]['value']
                else if (this.transformation.parameters[i]['name'] == 'numOfChars') this.localTransformation.numOfChars = this.transformation.parameters[i]['value']
                else if (this.transformation.parameters[i]['name'] == 'separator') this.localTransformation.separator = this.transformation.parameters[i]['value']
                else if (this.transformation.parameters[i]['name'] == 'outputColumn1') this.localTransformation.outputColumn1 = this.transformation.parameters[i]['value']
                else if (this.transformation.parameters[i]['name'] == 'separator') this.localTransformation.separator = this.transformation.parameters[i]['value']
                else if (this.transformation.parameters[i]['name'] == 'outputColumn1') this.localTransformation.outputColumn1 = this.transformation.parameters[i]['value']
                else if (this.transformation.parameters[i]['name'] == 'outputColumn2') this.localTransformation.outputColumn2 = this.transformation.parameters[i]['value']
                else if (this.transformation.parameters[i]['name'] == 'outputType1') this.localTransformation.outputType1 = this.transformation.parameters[i]['value']
                else if (this.transformation.parameters[i]['name'] == 'outputType2') this.localTransformation.outputType2 = this.transformation.parameters[i]['value']
                else if (this.transformation.parameters[i]['name'] == 'columns') this.localTransformation.column = this.transformation.parameters[i]['value'][0]
            }
        }
    },
    methods: {
        getStringColumns(columns: Array<IDataPreparationColumn>): Array<IDataPreparationColumn> {
            return columns.filter((x) => x.Type == 'java.lang.String')
        },
        translatedLabel(item) {
            return this.$t(item.label)
        }
    },
    watch: {
        localTransformation: {
            handler(newValue, oldValue) {
                if (oldValue !== newValue) {
                    this.$emit('update:transformation', newValue)
                }
            },
            deep: true
        }
    }
})
